function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgUploadCloud = function SvgUploadCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12.75 13.803v7.195a.75.75 0 01-1.5 0v-7.195l-2.714 2.725a.75.75 0 01-1.06-1.06l4-4a.75.75 0 011.06 0l4 4a.75.75 0 01-1.06 1.06l-2.726-2.725zM9.993 2.307a8.75 8.75 0 017.313 5.94h.7a5.75 5.75 0 012.748 10.8.75.75 0 01-.718-1.318 4.25 4.25 0 00-2.03-7.981h-1.26a.75.75 0 01-.727-.563 7.25 7.25 0 10-12.452 6.616.75.75 0 11-1.124.993 8.75 8.75 0 017.55-14.487z"
  }));
};

SvgUploadCloud.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgUploadCloud.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgUploadCloud;